export default __webpack_public_path__ + "static/media/affairs.c6571b51.svg";